import React, {
  useEffect, useState, useContext,
} from 'react';
import { AnyProps } from '../types';
import { RocheContactCard } from './contact-card';
import { PageStateContext } from '../../services';

export const RocheContactCardPerson = (
  {
    blok, getComponent, slot,
  }: AnyProps,
): JSX.Element => {
  const contactsContent = blok.contacts?.map((item) => item.content) || [];

  const { translations = {} } = useContext(PageStateContext);
  const [contact, setContact] = useState(null);

  const setContactCardProps = (data, multipleContacts = false) => {
    if (!data) return null;
    return {
      ...data,
      layout: blok.card_layout,
      slotted_media: blok.image,
      ...(multipleContacts ? {
        firstname: contactsContent
          .map(({ firstname = '', lastname = '' }) => `${firstname} ${lastname}`)
          .join(` ${translations.and || 'und'} `),
        lastname: '',
        description: blok.description,
        job_title: '',
        slotted_links: blok.links,
      } : {}),
    };
  };

  useEffect(() => {
    setContact(setContactCardProps(contactsContent[0], contactsContent.length > 1));
  }, [blok.contacts, translations.and]);

  return contact && <RocheContactCard
    slot={slot}
    blok={contact}
    getComponent={getComponent}
  />;
};
